import React from 'react';
import styled from 'styled-components'

const LogoContainer = styled.div`
  flex: 1 0 auto;
  justify-content: center;
  display: flex;
  @media (min-width: 600px) {
    margin-right: -100px;
  }
  /* padding: 10px; */
  /* box-sizing: border-box;
  margin: 3px; */
`

const Img = styled.img`
&& {
  flex: 0 0 auto;
  background-size: contain;
}
`

function LogoFrente(props) {
  return (
    <LogoContainer {...props}>
      <Img
        src={`${process.env.PUBLIC_URL}/img/w-transparente-cromado-pq.png`}
        style={{ paddingRight: '30px' }}
      />
      <Img
        src={`${process.env.PUBLIC_URL}/img/wc-transparente-cromado-pq.png`}
      />
    </LogoContainer>
  );
}

export default LogoFrente;
